<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="formGroups" :viewMode="viewMode">
    </MyForm>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import staffDetailMixin from "../mixin/detail";

export default {
  name: "StaffDriverDetail",
  mixins: [detailMixin, staffDetailMixin],
  data() {
    return {
      baseUrl: 'driver',
      breadcrumb: [
        { name: "人员管理", path: "/staff/driver" },
        { name: "司机管理", path: "/staff/driver" },
        { name: "添加司机" },
      ],
    };
  },
  methods: {
    setOptions({ iswork, edu, team, basedriver, roydriver }) {
      this.formGroups[0].formCtrl.map(c => {
        if (c.keyName == 'nation' && this.NATION) {
          // console.log({...c})
          c.options = this.NATION.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })
          // 没有姓名说明是新建信息
          if (!this.form.name) this.form.nation = this.NATION[0].name
          // console.log([...c.options])
          // console.log({...this.form})
        } else if (c.keyName == 'isworkname' && iswork) {
          this.iswork = { ...iswork }
          for (const key in iswork) {
            if (Object.hasOwnProperty.call(iswork, key)) {
              const val = iswork[key];
              // -------- 在职 --- 1
              this.iswork2[val] = key
              c.options.push({
                label: val,
                value: val,
              })
            }
          }
          if (!this.form.name) {
            this.form.iswork = '1'
            this.checkIsWork()
          }
          // console.log([...c.options])
          // console.log({...this.form})
        } else if (c.keyName == 'iswork' && iswork) {
          for (const key in iswork) {
            if (Object.hasOwnProperty.call(iswork, key)) {
              const val = iswork[key];
              c.options.push({
                label: val,
                value: key,
              })
            }
          }
          this.form.iswork = '1'
          // console.log([...c.options])
          // console.log({...this.form})
        }
        if (c.keyName == 'edu' && edu.length) {
          c.options = edu.map(v => {
            return {
              label: v.eduname,
              value: v.eduname,
            }
          })
          this.form.edu = edu[0].eduname
        }
        if (c.keyName == 'fleet' && team.length) {
          c.options = team.map(v => {
            return {
              label: v.nickname + '车队',
              value: v.id,
            }
          })
          this.form.fleet = team[0].id
        }
        if (basedriver && !this.form.basedriver) {
          this.form.basedriver = basedriver
        }
        if (roydriver && !this.form.roydriver) {
          this.form.roydriver = roydriver
        }
      })
    },
  },
  created() {
    // this.formGroups[0].formCtrl.unshift({
    //   label: "车队",
    //   keyName: "fleet",
    //   err: "请选择车队",
    //   type: "select",
    //   options: [],
    // })
    this.formGroups[0].formCtrl.splice(12, 0, {
      label: "基本工资(元)",
      keyName: "basedriver",
      err: "请填写基本工资",
      type: "number",
    })
    this.formGroups[0].formCtrl.push({
      label: "驾驶员驾驶证",
      keyName: "driverslicense",
      type: "file",
      ptype: "person",
      tips: "最多上传2张图片",
      max: 2,
      className: "block",
    })
    this.formGroups[0].formCtrl.push({
      label: "驾驶员从业资格证",
      keyName: "certificate",
      type: "file",
      ptype: "person",
      tips: "最多上传2张图片",
      max: 2,
      className: "block",
    })
    this.getOptions();
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.btns {
  padding: 40px 0 60px 180px;
}
</style>
